import { render, staticRenderFns } from "./DrugProducts.vue?vue&type=template&id=4b59f5dc"
import script from "./DrugProducts.vue?vue&type=script&lang=js"
export * from "./DrugProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports